import React from 'react';
import { STATUS, STATUS_LABELS } from '../state/model';

// Small colored pill conveying a field's data status. The color language is the
// same everywhere so a user can scan a dense matrix and instantly see what is
// approved vs. auto-extracted vs. missing vs. conflicting.
// Tones matched to the property-results page status palette (design-system.css):
// emerald success, amber-orange warning, cerulean info, punch-red error.
const COLORS = {
  [STATUS.APPROVED]: { bg: 'rgba(16,185,129,0.13)', fg: '#047857', bd: 'rgba(16,185,129,0.34)' },
  [STATUS.AUTO]: { bg: 'rgba(245,158,11,0.13)', fg: '#b45309', bd: 'rgba(245,158,11,0.34)' },
  [STATUS.MANUAL]: { bg: 'rgba(41,133,173,0.10)', fg: '#206b8e', bd: 'rgba(41,133,173,0.26)' },
  [STATUS.ESTIMATED]: { bg: 'rgba(126,149,255,0.14)', fg: '#4655c0', bd: 'rgba(126,149,255,0.34)' },
  [STATUS.MISSING]: { bg: 'rgba(102,112,133,0.12)', fg: '#667085', bd: 'rgba(102,112,133,0.24)' },
  [STATUS.CONFLICT]: { bg: 'rgba(220,38,38,0.09)', fg: '#dc2626', bd: 'rgba(220,38,38,0.28)' },
};

export default function StatusBadge({ status, title }) {
  const c = COLORS[status] || COLORS[STATUS.MISSING];
  return (
    <span
      className="rd-status-badge"
      title={title || STATUS_LABELS[status]}
      style={{ background: c.bg, color: c.fg, borderColor: c.bd }}
    >
      {STATUS_LABELS[status] || status}
    </span>
  );
}
